import { Timestamp } from 'firebase/firestore';

function isFirestoreTimestamp(value: unknown): value is Timestamp {
  return (
    value !== null &&
    typeof value === 'object' &&
    'toDate' in value &&
    typeof (value as Timestamp).toDate === 'function'
  );
}

/**
 * Converte `Timestamp` do Firestore em `Date` recursivamente em objetos simples.
 */
export function mapFirestoreTimestampsToDates(value: unknown): unknown {
  if (isFirestoreTimestamp(value)) {
    return value.toDate();
  }
  if (Array.isArray(value)) {
    return value.map(mapFirestoreTimestampsToDates);
  }
  if (value !== null && typeof value === 'object' && !(value instanceof Date)) {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      out[k] = mapFirestoreTimestampsToDates(v);
    }
    return out;
  }
  return value;
}

/**
 * Remove chaves `undefined` (Firestore não aceita) em um nível; objetos aninhados são copiados sem alteração profunda.
 */
export function stripUndefinedForFirestore(obj: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === undefined) continue;
    out[k] = v;
  }
  return out;
}
